import { useUrlGenerator } from '@folklore/routes';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import { useThemeClassName } from '../../contexts/ThemeContext';
import Button from '../buttons/Button';

// import * as AppPropTypes from '../../lib/PropTypes';
import styles from '../../../styles/partials/points-earned.module.scss';

const propTypes = {
    className: PropTypes.string,
    points: PropTypes.number,
    expirationWeekday: PropTypes.number,
    prizesPageUrl: PropTypes.string,
};

const defaultProps = {
    className: null,
    points: 0,
    expirationWeekday: null,
    prizesPageUrl: null,
};

function PointsEarned({ className, points, expirationWeekday, prizesPageUrl }) {
    const themeClassName = useThemeClassName(styles);
    const url = useUrlGenerator();

    return (
        <div className={classNames([styles.container, themeClassName, className])}>
            <div className={styles.inner}>
                <Button href={prizesPageUrl || url('account')} className={styles.col}>
                    {prizesPageUrl !== null ? (
                        <span className={styles.center}>
                            <FormattedMessage
                                defaultMessage="See prizes"
                                description="Button label"
                            />
                        </span>
                    ) : null}
                </Button>
                <Button href={url('account')} className={classNames([styles.col, styles.last])}>
                    <span className={styles.label}>
                        {expirationWeekday !== null ? (
                            <FormattedMessage
                                defaultMessage="Points earned this week"
                                description="Points earned label"
                            />
                        ) : (
                            <FormattedMessage
                                defaultMessage="Points earned"
                                description="Points earned label"
                            />
                        )}
                        <span className={styles.points}>{`${points} pts`}</span>
                    </span>
                </Button>
            </div>
        </div>
    );
}

PointsEarned.propTypes = propTypes;
PointsEarned.defaultProps = defaultProps;

export default PointsEarned;
